<div class="sh-headpanel" style="display: flex; align-items: center;">

  <app-nav-btns-left [navBtnsLeft]="btnsLeft"></app-nav-btns-left>
  <app-nav-btns-right [profileDdwnBtns]="profileDdwnBtns" [navBtnsRight]="btnsRight"></app-nav-btns-right>
</div><!-- sh-headpanel -->
